import { useEffect, useState } from 'react';

const useKeyboard = () => {
	const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

	// Minimum tinggi yang dianggap sebagai kemunculan keyboard
	const minKeyboardHeight = 150;

	useEffect(() => {
		const listener = () => {
			if (!window.visualViewport) return;

			const heightDiff = window.screen.height - window.visualViewport.height;
			const keyboardShown = heightDiff > minKeyboardHeight;

			setIsKeyboardVisible(keyboardShown);
		};

		if (typeof window.visualViewport !== 'undefined') {
			window.visualViewport.addEventListener('resize', listener);
		}

		return () => {
			if (typeof window.visualViewport !== 'undefined') {
				window.visualViewport.removeEventListener('resize', listener);
			}
		};
	}, []);

	return isKeyboardVisible;
};

export default useKeyboard;
